import Keycloak from 'keycloak-js';
import {KeycloakProvider} from '@react-keycloak/web';
import Spinner from 'App/Spinner';
import HandleRefresh from './HandleRefresh';
import {getConfig} from '../config';

export const realm = (function(hostname){
  const domain = getConfig("KEYCLOAK_REALM_DOMAIN") || "fees.fi";
  const re = new RegExp(`^([^.]+)\\.${RegExp.escape(domain)}$`);
  const m = re.exec(hostname);
  if (m != null) {
    return `nordnet-fees-${m[1]}`;
  }
	return getConfig("KEYCLOAK_REALM");
})(window.location.hostname);

const keycloak = new Keycloak({
  clientId: getConfig("KEYCLOAK_CLIENT_ID"),
  realm,
  url: getConfig("KEYCLOAK_URL")
});

export default ({children}) => (
  <KeycloakProvider keycloak={keycloak} LoadingComponent={<Spinner/>}>
    <>
      <HandleRefresh/>
      {children}
    </>
  </KeycloakProvider>
);
